module.exports = __webpack_public_path__ + "static/img/img-dg1.cc29759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/img-dg1.png
// module id = A5qj
// module chunks = 0